import "./empleos.css";
import EmploymentSection from "./employmentsection";
import "./employmentsection.css";
import RegisterTwo from "../../components/registertwo";
import Employer from "../../components/employer";
import { FaBriefcase, FaBook, FaUserTie } from "react-icons/fa";

const Empleos = () => {
  return (
    <div className="empleos-page">
      {/* Sección de encabezado para Empleos */}
      <EmploymentSection />

      <div className="empleos-main container text-center">
        {/* Fila de tarjetas */}
        <div className="row g-4 mb-4">
          {/* Tarjeta: Recursos Laborales */}
          <div className="col-md-4">
            <div className="card empleo-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBriefcase className="icon" />
                </div>
                <h2 className="empleo-card-title">Recursos Laborales</h2>
                <p className="text-muted">
                  Herramientas y consejos para conseguir tu próximo empleo.
                </p>
                <button className="btn btn-warning">Explorar Ahora</button>
              </div>
            </div>
          </div>
          {/* Tarjeta: Educación y Coaching */}
          <div className="col-md-4">
            <div className="card empleo-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBook className="icon" />
                </div>
                <h2 className="empleo-card-title">Educación y Coaching</h2>
                <p className="text-muted">
                  Impulsa tu crecimiento profesional con nuestros programas.
                </p>
                <div className="button-group">
                  <button className="btn btn-warning">Programas de Asesoría</button>
                  <button className="btn btn-warning">Oportunidades Educativas</button>
                </div>
              </div>
            </div>
          </div>
          {/* Tarjeta: Recursos para Empleadores */}
          <div className="col-md-4">
            <div className="card empleo-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaUserTie className="icon" />
                </div>
                <h2 className="empleo-card-title">Recursos para Empleadores</h2>
                <p className="text-muted">
                  Herramientas para gestionar candidatos y optimizar tus contrataciones.
                </p>
                <button className="btn btn-warning">Descubrir Recursos</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sección adicional: Registro y Empleador (full width) */}
      <div className="empleos-additional">
        <RegisterTwo />
        <Employer />
      </div>
    </div>
  );
};

export default Empleos;